import axios from 'axios';
import React, { useState } from 'react';
import styled from 'styled-components';
import PrimaryButton from '../Shared/Buttons/PrimaryButton';
import SecondaryHeading from '../Shared/Heading/SecondaryHeading';
import FeedBackPopup from '../Shared/Popups/FeedBackPopup';

const AddPlotForm = ( { plotEdit, edit }: any ) => {

    // console.log( 'in add plot ', plotEdit.type, edit );

    if ( edit ) {
        console.log( 'see ', plotEdit );
        if ( plotEdit === undefined || plotEdit === null || plotEdit.length === 0 ) {
            window.location.replace( '/' );
        } 

    }

    const [ popupOpen, setPopupOpen ] = useState( false );
    const [ feedBackText, setFeedBackText ] = useState( '' );
    const [ feedBackType, setFeedBackType ] = useState( '' );

    const [ type, setType ] = useState( edit && plotEdit.type  ? plotEdit.type : '' );
    const [ subType, setSubType ] = useState( edit ? plotEdit.subType : '' );
    const [ propertyName, setPropertyName ] = useState( edit ? plotEdit.propertyName : '' );
    const [ description, setDescription ] = useState( edit ? plotEdit.description : [ '' ] );
    const [ address, setAddress ] = useState( edit ? plotEdit.address : '' );
    const [location, setLocation ] = useState( edit ? plotEdit?.location : '');
    const [ addressMapLink, setAddressMapLink ] = useState( edit ? plotEdit.addressMapLink : '' );
    const [ amenties, setAmenties ] = useState( edit ? plotEdit.amenties : [ '' ] );
    const [ nearbyLocatioin, setNearbyLocation ] = useState( edit ? plotEdit.nearbyLocation : '' );
    const [ videoLink, setVideoLink ] = useState( edit ? plotEdit.videoLink : [ '' ] );
    const [ imageLink, setImageLink ] = useState( edit ? plotEdit.imageLink : [ '' ] );



    const popupHandler = ( ) => {

        setTimeout( ( ) => { 

            setPopupOpen( popupOpen => !popupOpen );
            window.location.replace( '/plots' );

        }, 2000 );
    }

    const submitHandler = ( e: any ) => {

        e.preventDefault( );
        console.log( 'click' );
        const obj = {
            "type": type,
            "subType": subType,
            "propertyName": propertyName,
            "description": description,
            "address": address,
            "location": location,
            "addressMapLink": addressMapLink,
            "amenties": amenties,
            "nearbyLocation": nearbyLocatioin,
            "videoLink": videoLink,
            "imageLink": imageLink
        }

        const tokenConfig = {
            headers: {
                accept: "/*/",
                "content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("shreeDevToken"),
            },
        };

        if ( !edit ) {
            axios.put( `https://shreee-development-test.herokuapp.com/admin/property`, obj, tokenConfig )
            .then( ( res: any ) => {
                console.log( 'Success Add ', res );
                setFeedBackText( 'Successfully Added!' );
                setFeedBackType( 'success' );
                setPopupOpen( popupOpen => !popupOpen );
                popupHandler( );
            } )
            .catch( ( e: any ) => {
                console.log( 'error add ', e );
                setFeedBackText( 'Some Error Occured!' );
                setFeedBackType( 'error' );
                setPopupOpen( popupOpen => !popupOpen );
                popupHandler( );
                window.location.replace( '/' );
            } ) 

        }
        else {
            console.log( 'editing ', tokenConfig );
            axios.patch( `https://shreee-development-test.herokuapp.com/admin/property/${ plotEdit._id }`, obj, tokenConfig )
            .then( ( res: any ) => {
                console.log( 'Success Add ', res );
                setFeedBackText( 'Successfully Saved!' );
                setFeedBackType( 'success' );
                setPopupOpen( popupOpen => !popupOpen );
                popupHandler( );

            } )
            .catch( ( e: any ) => {
                console.log( 'error add ', e );
                setFeedBackText( 'Some Error Occured!' );
                setFeedBackType( 'error' );
                setPopupOpen( popupOpen => !popupOpen );
                popupHandler( );
                window.location.replace( '/' );
            } )

        }


    }

    return (

        <AddPlotWrapper>
            <SecondaryHeading text = { edit ? 'Edit Property' : 'Add Property' } />
            <form>
                <div className="property-row sec1">
                    <div className="property-name">
                        Property Name: 
                        <input type="text" value = { propertyName } onChange = { ( e ) => setPropertyName( e.target.value ) }

                        />
                    </div>
                    <div className="property-type">
                        Type: 
                        <input type="text" value = { type } onChange = { ( e ) => setType( e.target.value ) } />
                    </div>
                    <div className="property-type">
                        Sub Type: 
                        <input type="text" value = { subType } onChange = { ( e ) => setSubType( e.target.value ) } />
                    </div>
                </div>
                <div className="property-address sec1">
                    <div className="address">
                        Address: <br /> <textarea name="address" value={ address } onChange = { ( e ) => setAddress( e.target.value ) } id="" cols= {40} rows={5}></textarea>
                    </div>
                    <div className="address">
                        Location: <br /> <input name="location" value={ location } onChange = { ( e ) => setLocation( e.target.value ) } id=""></input>
                    </div>
                    <div className="address">
                    Nearby Locations:<br /> <textarea name="nearbylocation" value={ nearbyLocatioin } onChange = { ( e ) => setNearbyLocation( e.target.value ) } id="" cols= {40} rows={5}></textarea>
                    </div>
                    <div className="address-map-link property-link">
                        Address Map Link: <input type="text" value = { addressMapLink } onChange = {  ( e ) => setAddressMapLink( e.target.value )  } />
                    </div>
                </div>
                {/* <div className="near-by-location property-address sec1">
                    <div className="address">
                    Nearby Location:<br /> <textarea name="nearbylocation" value={ nearbyLocatioin } onChange = { ( e ) => setNearbyLocation( e.target.value ) } id="" cols= {50} rows={5}></textarea>
                    </div>
                </div> */}
                <div className="description sec1">
                    Description: <br />
                    {
                        description.map( ( item: any, index: number ) => {

                            return (
                                <textarea name="" id="" cols={60} rows={3}
                                value = { item } onChange = { ( e ) => { 
                                    let newArray = [ ...description ];
                                    newArray[ index ] = e.target.value;
                                    setDescription( newArray );
                                } } >
                                </textarea>
                            )

                        } )
                    }
                    <div className="action-button">
                        <button className='add-more' onClick = { ( e ) => { e.preventDefault(); setDescription( ( description: any ) => [ ...description, '' ] ) } } >Add More</button>
                        <button className='delete-last' onClick = { ( e ) => { e.preventDefault(); setDescription( ( description: any ) =>  description.slice( 0, -1 ) ) } } >Delete Last</button>
                    </div>
                </div>
                <div className="description sec1">
                    Amenities: <br />
                    {
                        amenties.map( ( item: any, index: number ) => {

                            return (
                                <textarea name="" id="" cols={60} rows={3}
                                value = { item } onChange = { ( e ) => { 
                                    let newArray = [ ...amenties ];
                                    newArray[ index ] = e.target.value;
                                    setAmenties( newArray );
                                } } >
                                </textarea>
                            )

                        } )
                    }
                    <div className="action-button">
                        <button className='add-more' onClick = {  ( e ) => { e.preventDefault(); setAmenties( ( amenties: any ) => [ ...amenties, '' ] ) } } >Add More</button>
                        <button className='delete-last' onClick = { ( e ) => { e.preventDefault(); setAmenties( ( amenties: any ) =>  amenties.slice( 0, -1 )  ) } } >Delete Last</button>
                    </div>
                </div>
                <div className="image-link-area description sec1">
                    Image Link: <br />
                    {
                        imageLink.map( ( item: any, index: number ) => {

                            return (
                                <input type = 'text' value = { item } onChange = { ( e ) => { 
                                    let newArray = [ ...imageLink ];
                                    newArray[ index ] = e.target.value;
                                    setImageLink( newArray );
                                } } />
                            )

                        } )
                    }
                    <div className="action-button">
                        <button className='add-more' onClick = { ( e ) => { e.preventDefault(); setImageLink( ( imageLink: any ) => [ ...imageLink, '' ] ) } } >Add More</button>
                        <button className='delete-last' onClick = { ( e ) => { e.preventDefault(); setImageLink( ( imageLink: any ) =>  imageLink.slice( 0, -1 )  ) } } >Delete Last</button>
                    </div>
                </div>
                <div className="image-link-area description sec1">
                    Video Link: <br />
                    {
                        videoLink.map( ( item: any, index: number ) => {

                            return (
                                <input type = 'text' value = { item } onChange = { ( e ) => { 
                                    let newArray = [ ...videoLink ];
                                    newArray[ index ] = e.target.value;
                                    setVideoLink( newArray );
                                } } />
                            )

                        } )
                    }
                    <div className="action-button">
                        <button className='add-more' onClick = { ( e ) => { e.preventDefault(); setVideoLink( ( video: any ) => [ ...video, '' ] ) } } >Add More</button>
                        <button className='delete-last' onClick = { ( e ) => { e.preventDefault(); setVideoLink( ( video: any ) =>  video.slice( 0, -1 )  ) } } >Delete Last</button>
                    </div>
                </div>
                <div className="submit-btn">
                {
                    <PrimaryButton 
                        actionHandler = { submitHandler } 
                        text = { edit ? 'Update' : 'Save' } 
                    />   
                }
                </div>                
            </form>
            {
                popupOpen ? 
                <FeedBackPopup 
                    text = { feedBackText } 
                    type = { feedBackType } 
                    actionHandler = { ( ) => {
                         setPopupOpen( popupOpen => !popupOpen );
                         window.location.replace( '/plots' );
                    } }  
                /> 
                : 
                ''
            }
        </AddPlotWrapper>
    )
}

export default AddPlotForm;




const AddPlotWrapper = styled.div`

    margin: 3rem 2rem;
    .property-row, .property-address {
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
        margin: 20px;
        .property-name {
            /* width: 50%; */

        }
    }
    .property-row :first-child {
        width: 50%;
    }
    .property-address {
        /* margin: 0; */
    }
    .address {
        display: flex;
        justify-content: left;
        align-items: center;

    }
    .address, .description {
        margin: 0 1rem;
    }
    .description {
        display: flex;
        /* flex-direction: column; */
        justify-content: left;
        align-items: center;
        flex-wrap: wrap;
        button {
            width: 100px;
            padding: 5px;
            font-size: 16px;
            font-weight: bolder;
            outline: none;
            background: transparent;
            border-radius: 5px;
        }
    }
    .add-more {
        border: 2px solid green;
        margin: 10px;
    }
    .delete-last {
        border: 2px solid red;
        margin: 10px;
    }
    .image-link-area {

        width: 50%;
    }
    textarea {
        padding: 10px;
        margin: 20px;
        font-size: 18px;
        background: transparent;
    }

    .action-button {
        margin: 10px;
        
    }
    


    input {
        border: none;
        border-bottom: 1px solid black;
        outline: none;
        font-size: 20px;
        padding: 10px;
        margin: 20px;
        background: transparent;
    }

    .sec1 {
        margin-top: 1rem;
        background: rgba( 241, 187, 85, 0.4);
        /* color: rgb(); */
        border: 1px dotted black;
        border-radius: 5px;
        padding: 10px;
    }

    .submit-btn {

        text-align: center;
        margin: 2rem;
        background: rgba(135, 240, 135, 0.5);
        padding: 20px;
    }
`;